<template>
    <div :aria-labelledby="name" class="my-2" :class="containerClass">
        <div class="flex gap-4 flex-wrap" :class="inline ? 'flex-row' : 'flex-col'">
            <div
                v-for="option in options"
                :key="option.value"
                @click="$emit('update:selected', option.value)"
                @keyup.enter="$emit('update:selected', option.value)"
                class="cursor-pointer"
            >
                <div class="flex flex-row gap-2 items-center">
                    <span
                        tabindex="0"
                        class="flex-none border border-blue text-white rounded-full flex items-center justify-center p-0.5 text-xs w-5 h-5"
                        :class="selected === option.value ? 'bg-blue' : 'bg-white'"
                    >
                        <div class="w-3 h-3 bg-white rounded-full" v-if="option.value === selected"></div>
                    </span>
                    <span class="dark:text-white" v-html="$translate(option.label)"> </span>
                </div>
            </div>
        </div>
        <FormError :formComponentId="formComponentId" :name="name" v-model:status="status" />
    </div>
</template>

<script>
export default {
    props: {
        options: Array,
        selected: String,
        name: String,
        formComponentId: '',

        inline: Boolean,
        containerClass: String
    },

    emits: ['update:selected'],

    data: () => ({
        status: null
    })
};
</script>
